<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="我的服务"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="page">
      <div class="mainWrap">
        <div class="list_box">
          <van-pull-refresh
            v-model="refreshingParking"
            @refresh="onRefreshParking"
            success-text="刷新成功"
            :disabled="errorFlagParking"
          >
            <van-list
              v-model="loadingParking"
              :finished="finishedParking"
              :immediate-check="false"
              :finished-text="parkingRecordList.length===0?'':'没有更多了'"
              :error.sync="errorParking"
              error-text="请求失败，点击重新加载"
              @load="onLoadParking"
            >
              <div
                class="group_recharge"
                v-for="item in parkingRecordList"
                :key="item.id"
              >
                <div class="itemBox">
                  <div class="mainBox">
                    <div class="mainBoxLeft">
                      <!-- <img
                        src="../../../assets/img/fapiaojilu2@2x.png"
                        class="mainBoxLeftIcon"
                      /> -->
                      <div class="mainBoxLeftCenter">
                        <div class="mainBoxLeftCenterNum">
                          <div class="plateLeftBox">
                            <span>{{ item.plate_number }}</span>
                            <span v-if="item.group_name" :class="['vhGroup', item.group_name?'vhCateLeft':'']">{{item.group_name}}</span>
                            <span :class="['tit', 'vhCate']">{{ item.vh_cate_name }}</span>
                          </div>

                          <span :class="['tit',stateClassFormatter(item)]">{{ stateFormatter(item) }}</span>
                        </div>
                        <!-- TODO可能会有多个时间段展示 -->
                        <span class="mainBoxLeftCenterType">
                          {{ dateFormatter(item)}}
                        </span>
                        <!-- <span class="mainBoxLeftCenterType">
                          {{ ruleTextFormatter(item) }}
                        </span> -->
                        <!-- <span decode="true" class="mainBoxLeftCenterDate">
                          <div class="circleInBox">
                            <span class="circleIn"></span>
                          </div>
                          <span class="date_tit"> 进场时间：</span>
                          {{ formattedDate(item.in_time) }}
                        </span> -->
                        <!-- <span decode="true" class="mainBoxLeftCenterDate">
                          <div class="circleOutBox">
                            <span class="circleOut"></span>
                          </div>
                          <span class="date_tit"> 出场时间：</span>
                          {{ formattedDate(item.out_time) }}
                        </span> -->
                      </div>
                    </div>
                    <!-- <div class="mainBoxRight">
                      <span class="mainBoxRightMoney">{{ item.money }}元</span>
                    </div> -->
                  </div>
                  <!-- <div
                    class="lineline"
                    v-if="parkingRecordList.length - 1 !== index"
                  ></div> -->
                </div>
              </div>
              </van-list>
          </van-pull-refresh>
          <!-- 空状态 -->
          <van-empty
            v-if="parkingRecordList.length == 0"
            description="暂无匹配数据"
          />
          <van-empty
            v-if="parkingRecordList.length !== 0 && isError"
            image="error"
            description="查询异常"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import DateSelect from '../../../components/DateSelect.vue'
// import Pagination from '../../../components/Pagination.vue'
import * as common from '../../../api/common'
import * as api from '../../../api/api'
import * as parkService from '../../../api/parkService'
import * as util from '../../../api/util'
// import { Toast } from 'vant'
import { mapState, mapGetters } from 'vuex'
import { Toast } from 'vant'
// import moment from 'moment'
export default {
  // components: { DateSelect, Pagination },
  components: { DateSelect },
  data () {
    return {
      tokenInfoObj: {},
      active: 0,
      show: false,
      vhColumnsLocal: [],
      index: 0,
      index2: 0,
      recentDates: '',
      lastAmonth: '',
      lastThreeParking: '',
      plateNum: '',
      user_info: {},
      token: '',
      parkPayRecordList: [
      ],
      parkingRecordList: [
      ],
      isError: false,
      showVhPopup: false,
      selVhVal: '',
      showDatePopup: false,
      pageOption: {
        page_no: 1,
        page_size: 10,
        total: 0
      },
      loadingParking: false,
      finishedParking: false,
      refreshingParking: false,
      errorParking: false,
      errorFlagParking: false,
      parkName: '',
      qryFlag: false,

      noStart: 'noStart',
      inEffect: 'inEffect',
      expired: 'expired'
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.queryParkingRecord()
    })
  },
  computed: {
    ...mapState({
      sid: (state) => state.sid.sid
    }),
    ...mapGetters(['vhColumns', 'openID'])
  },
  methods: {
    // 有效期格式化
    dateFormatter (item) {
      if ((item.effective_date_start || item.current_effective_date_start) && (item.effective_date_end || item.current_effective_date_end)) {
        const startDate = common.fmtDate(item.effective_date_start || item.current_effective_date_start, 'yyyy-MM-dd')
        const endDate = util.judgeEndDateLong(item.effective_date_end || item.current_effective_date_end) ? '长期有效' : common.fmtDate(item.effective_date_end || item.current_effective_date_end, 'yyyy-MM-dd')
        return `${startDate} 至 ${endDate}`
      }
    },
    stateClassFormatter (item) {
      let str = ''
      if (!item.effective_date_start && !item.effective_date_end && !item.current_effective_date_start && !item.current_effective_date_end) return ''
      const now = new Date()
      if (now.getTime() < new Date(item.effective_date_start || item.current_effective_date_start).getTime()) {
        str = this.noStart
      } else if (now.getTime() > new Date(item.effective_date_start || item.current_effective_date_start).getTime() && now.getTime() < new Date(item.effective_date_end || item.current_effective_date_end).getTime()) {
        str = this.inEffect
      } else {
        str = this.expired
      }
      return str
    },
    stateFormatter (item) {
      let str = ''
      if (!item.effective_date_start && !item.effective_date_end && !item.current_effective_date_start && !item.current_effective_date_end) return ''
      const now = new Date()
      if (now.getTime() < new Date(item.effective_date_start || item.current_effective_date_start).getTime()) {
        str = '未开始'
      } else if (now.getTime() > new Date(item.effective_date_start || item.current_effective_date_start).getTime() && now.getTime() < new Date(item.effective_date_end || item.current_effective_date_end).getTime()) {
        str = '生效中'
      } else {
        str = '已过期'
      }
      return str
    },
    ruleTextFormatter (item) {
      if (item.id === 0) {
        return '包租时段内全时段生效'
      } else {
        return item.startTime + ' - ' + item.endTime
      }
    },
    // 根据sid查询车场信息
    async query_customer_by_sid () {
      try {
        const parkInfo = await parkService.queryCustomerBySid(this.sid)
        if (parkInfo) {
          this.parkName = parkInfo.parkname
          // 保存车场名称
          localStorage.setItem('park_name', this.parkName)
        }
      } catch (error) {
        console.error('查询车场信息失败:', error)
        this.$toast.fail('获取车场信息失败')
      }
    },
    parkingTimeFormatter (item) {
      // {
      //   minutes: 12
      //   seconds: 48
      // }
      if (item.parked_time) {
        const { hours, minutes, seconds } = item.parked_time
        let timeStr = ''
        if (hours) {
          timeStr += `${hours}小时`
        }
        if (minutes) {
          timeStr += `${minutes}分钟`
        }
        if (seconds) {
          timeStr += `${seconds}秒`
        }
        return timeStr
      }
    },
    formattedDate (dateString) {
      return dateString.replace(/-/g, '/') //
    },
    formatDate (date) {
      return common.fmtDate(date, 'yyyyMM/dd hh:mm:ss')
    },
    // 查询停车记录
    async queryParkingRecord () {
      // this.selVhVal = '浙AQW001'
      Toast.loading({
        forbidClick: true,
        message: '请稍候...'
      })
      try {
        if (!this.sid) {
          this.$toast.fail('车场编码丢失，请返回首页重试或者重新扫码进入！')
          return
        }
        // 验证必要参数
        if (!this.openID) {
          Toast.clear()
          this.$toast.fail('用户信息丢失，请重新登录！')
          this.isError = true
          return
        }

        // 动态导入 IotService
        const { IotService } = await import('../../../api/iotService')
        
        // 调用API获取数据
        const res = await IotService.callUuidApi(api.urlList.car_owner.vh.get_rent_history, {
          version: 'v2',
          access_token: 'CA502D23-BB70-0001-55FA-1B501C501A6B',
          app_key: '666a659e-244d-46b1-a8cc-3c5190c3823a',
          sid: this.sid,
          openid: this.openID,
          begin_time: util.getDateBeforeMonths(3),
          page_no: this.pageOption.page_no,
          page_size: this.pageOption.page_size
        })
        
        // 清除加载状态
        Toast.clear()
        
        // 处理响应数据
        if (res.code === common.resCode.OK) {
          this.pageOption.total = res.total
          this.isError = false
          
          if (this.refreshingParking) {
            // 下拉刷新：替换所有数据
            this.parkingRecordList = res.list || []
            this.qryFlag = false
            this.loadingParking = false
            this.refreshingParking = false
          } else {
            // 上拉加载：追加数据
            this.parkingRecordList = [...this.parkingRecordList, ...(res.list || [])]
            this.loadingParking = false
            
            // 判断是否加载完成
            if (this.parkingRecordList.length >= res.total) {
              this.finishedParking = true
            }
          }
        } else {
          // API 返回错误
          this.$toast.fail(res.msg || '查询失败')
          this.isError = true
          this.loadingParking = false
          this.refreshingParking = false
        }
      } catch (error) {
        // 捕获所有异常
        Toast.clear()
        console.error('查询月租历史记录失败:', error)
        this.$toast.fail('网络异常，请稍后重试')
        this.isError = true
        this.loadingParking = false
        this.refreshingParking = false
      }
    },

    onClickLeft () {
      this.$router.go(-1)
    },
    async onRefreshParking () {
      console.log('正在刷新', this.refreshingParking)
      this.parkingRecordList = []
      this.finishedParking = false
      this.loadingParking = true
      await this.onLoadParking()
    },
    async onLoadParking () {
      // 监听到即执行
      console.log('滑到底了')
      //   再次调用 查询 下一页数据
      if (this.refreshingParking) {
        // 下拉刷新
        this.pageOption.page_no = 1
        await this.queryParkingRecord()
      } else {
        if (this.errorFlagParking) {
          // 说明上次加载失败 现在重新加载
          this.pageOption.page_no = 1
          this.errorFlagParking = false
          await this.queryParkingRecord()
          return false
        }
        // 触底加载
        if (this.parkingRecordList.length >= this.pageOption.total) {
          this.finishedParking = true
        } else {
          this.pageOption.page_no = this.pageOption.page_no + 1
          await this.queryParkingRecord()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
}
.mainWrap {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f8f7fc;
  height: 100vh;
  //   padding: 0.16rem 0;
  // overflow: hidden;
  .rightIcon {
    width: 0.08rem;
    height: 0.14rem;
    margin: 0.03rem 0 0.03rem 0.05rem;
  }
  .lineline {
    height: 0.01rem;
    background-color: #e2e2e2;
    margin-top: 0.07rem;
    margin-bottom: 0.07rem;
  }
  .query_box {
    width: 3.43rem;
    // height: 5rem;
    display: flex;
    flex-direction: column;
    .query_box_item {
      background-color: rgba(255, 255, 255, 1);
      position: relative;
      /* width: 686rpx; */
      // height: 2.5rem;
      flex-direction: row;
      display: flex;
      justify-content: space-between;
      padding: 0.09rem 0.16rem 0.09rem 0.16rem;
      .query_box_item_tit {
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 0.16rem;
        font-family: PingFangSC-Regular;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        // line-height: 1.375rem;
      }
      .query_box_item_right {
        /* width: 84rpx; */
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        margin: 0.01rem 0 0.01rem 0;
        .section {
          display: flex;
          /* width: 90rpx; */
          justify-content: space-between;
          align-items: center;
          .selPlateNum {
            font-size: 0.14rem;
          }
        }
      }
    }

    .query_box_item {
      background-color: rgba(255, 255, 255, 1);
      position: relative;
      // height: 2.5rem;
      flex-direction: row;
      display: flex;
      justify-content: space-between;
      padding: 0.09rem 0.16rem;
      .query_box_item_tit {
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 0.16rem;
        font-family: PingFangSC-Regular;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        // line-height: 1.375rem;
      }
      .query_box_item_right {
        /* width: 84rpx; */
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        margin: 0.01rem 0;
        .section {
          display: flex;
          /* width: 90rpx; */
          justify-content: space-between;
          align-items: center;
          .showCommon {
            font-size: 0.14rem;
          }
          .rightIcon {
            width: 0.08rem;
            height: 0.14rem;
            margin: 0.03rem 0 0.03rem 0.05rem;
          }
        }
        .image_4-1 {
          position: absolute;
          left: 0;
          top: -0.01rem;
          width: 3.42rem;
          height: 0.01rem;
          background-color: #f0f0f0;
        }
      }
    }
  }

  .list_box {
    // background-color: rgba(255, 255, 255, 1);
    // width: 3.43rem;
    width: 100%;
    align-self: center;
    margin-top: 0.16rem;
    display: flex;
    flex-direction: column;
    // padding: 0.08rem 0.01rem 0.01rem 0;
    // overflow-y: auto;
    .itemBox {
      //   width: 3.25rem;
      background-color: rgba(255, 255, 255, 1);

      flex-direction: column;
      display: flex;
      justify-content: space-between;
      //   margin: 0.04rem 0.07rem 0 0.1rem;
      margin-bottom: 0.16rem;
      padding: 0.16rem 0.16rem 0 0.16rem;
      .mainBox {
        // width: 3.25rem;
        // flex-direction: row;
        // display: flex;
        // justify-content: space-between;
        /* margin: 8rpx 14rpx 0 20rpx; */
        .mainBoxLeft {
          /* width: 280rpx; */
        //   flex-direction: row;
        //   display: flex;
        //   justify-content: space-between;
          .mainBoxLeftIcon {
            width: 0.2rem;
            height: 0.16rem;
            margin: 0.03rem 0 0.43rem 0;
          }
          .mainBoxLeftCenter {
            display: flex;
            flex-direction: column;
            // margin-left: 0.06rem;
            .mainBoxLeftCenterNum {
              overflow-wrap: break-word;
              color: #333;
              font-size: 0.16rem;
              font-family: PingFangSC-Regular;
              font-weight: normal;
              text-align: left;
              white-space: nowrap;
              line-height: 0.22rem;
              // margin-right: 0.39rem;
              margin-bottom: 0.16rem;
              display: flex;
              justify-content: space-between;
              .plateLeftBox{

              }
              .vhGroup {
                // margin-left: 0.05rem;
                padding: 0 0.05rem;
                font-size: 0.12rem;
                color: #fff;
                border-radius: 25px;
                background-color: #4797ea;
              }
              .vhCate {
                margin-left: 0.05rem;
                padding: 0 0.05rem;
                font-size: 0.12rem;
                color: #fff;
                border-radius: 25px;
                background-color: #70CF7E;
              }
               .vhCateLeft{
                margin-left: 0.05rem;
              }
              .noStart{
                color:#999;
              }
              .inEffect{
                color: #00c099;
              }
              .expired{
                color: #fd0062;
              }
            }
            .mainBoxLeftCenterType {
              overflow-wrap: break-word;
              color: #333;
              font-size: 0.14rem;
              font-family: PingFangSC-Regular;
              font-weight: normal;
              text-align: left;
              white-space: nowrap;
              line-height: 0.17rem;
              // margin: 0.04rem 0.55rem 0 0;
              margin-bottom: 0.16rem;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              .tit {
                margin-left: 0.12rem;
              }
            }

            .mainBoxLeftCenterDate {
              overflow-wrap: break-word;
              color: #333;
              font-size: 0.14rem;
              font-family: PingFangSC-Regular;
              font-weight: normal;
              text-align: left;
              white-space: nowrap;
              line-height: 0.17rem;
              // margin-top: 0.02rem;
              margin-bottom: 0.16rem;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              .circleInBox,
              .circleOutBox {
                width: 0.12rem;
                height: 0.12rem;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .circleIn,
              .circleOut {
                display: block;
                width: 0.05rem;
                height: 0.05rem;
                border-radius: 50%;
              }
              .circleIn {
                background-color: #00c099;
              }
              .circleOut {
                background-color: #fd0062;
              }
              .date_tit {
                color: #999;
                margin-left: 0.12rem;
              }
            }
          }
        }
        .mainBoxRight {
          margin-bottom: 0.19rem;
          display: flex;
          flex-direction: column;
          .mainBoxRightMoney {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.16rem;
            font-family: PingFangSC-Regular;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
            line-height: 0.22rem;
            margin-left: 0.17rem;
          }
        }
      }
    }
  }
}
</style>
